import BaseFilter from '../modules/filters/baseFilter';

const sections = document.querySelectorAll('.tab-banners');

sections.forEach(section => {
    const filterSwitcherWrapper = section.querySelector('.filter-switcher');
    const tabsContents = section.querySelectorAll('.tab-banners__tab-content');
    let filterSwitcherController = null;

    filterSwitcherController = new BaseFilter(filterSwitcherWrapper, section);

    const openTab = e => {
        const { detail } = e;
        const parseddDetail = parseInt(detail.value);
        if (tabsContents[parseddDetail]) {
            if (
                !tabsContents[parseddDetail].classList.contains(
                    'tab-banners__tab-content--active'
                )
            ) {
                document
                    .querySelector('.tab-banners__tab-content--active')
                    .classList.remove('tab-banners__tab-content--active');
                tabsContents[parseddDetail].classList.add(
                    'tab-banners__tab-content--active'
                );
            }
        }
    };

    section.addEventListener('filter-switcher-change', e => openTab(e));
});
